import {
  PackageRecurrenceEnum,
  PackageUnitTypeEnum,
  ServiceTypeEnum,
  UnitSizeEnum,
} from "@/__generated__/graphql";
import D1Lash from "@/assets/images/booking/1d-lash.png";
import D2Lash from "@/assets/images/booking/2d-lash.png";
import D3Lash from "@/assets/images/booking/3-4d-lash.png";
import D5Lash from "@/assets/images/booking/5-6d-lash.png";
import AllUnits from "@/assets/images/booking/aircon-all-units.png";
import ArmChair from "@/assets/images/booking/arm-chair.png";
import AromaticMassage from "@/assets/images/booking/aromatic-oil-massage.png";
import BabyCot from "@/assets/images/booking/baby-cot.png";
import BabyPram from "@/assets/images/booking/baby-pram.png";
import BlindsCurtain from "@/assets/images/booking/blinds-curtain.png";
import CallusTreatment from "@/assets/images/booking/callus-treatment.png";
import CatSitting from "@/assets/images/booking/cat-sitting.png";
import CatGrooming from "@/assets/images/booking/cat.png";
import Ceiling from "@/assets/images/booking/ceiling.png";
import Chair from "@/assets/images/booking/chair.png";
import ChemicalOverhaul from "@/assets/images/booking/chemical-overhaul.png";
import ChemicalWash from "@/assets/images/booking/chemical-wash.png";
import CarSeat from "@/assets/images/booking/child-seat.png";
import ClassicManicure from "@/assets/images/booking/classic-manicure.png";
import ClassicManiPedi from "@/assets/images/booking/classic-manipedi.png";
import ClassicPedicure from "@/assets/images/booking/classic-pedicure.png";
import CondenserWash from "@/assets/images/booking/condenser-wash.png";
import CurtainAddOn from "@/assets/images/booking/curtain-add-on.png";
import DayCurtain from "@/assets/images/booking/day-curtain.png";
import DeepTissueMassage from "@/assets/images/booking/deep-tissue-massage.png";
import DogSitting from "@/assets/images/booking/dog-sitting.png";
import DogGrooming from "@/assets/images/booking/dog.png";
import Ducted from "@/assets/images/booking/ducted.png";
import ExtendedMassage from "@/assets/images/booking/extended-massage.png";
import ExtensionRemoval from "@/assets/images/booking/extension-removal.png";
import FairyLash from "@/assets/images/booking/fairy-lash.png";
import FlowerLash from "@/assets/images/booking/flower-lash.png";
import FootMassage from "@/assets/images/booking/foot-massage.png";
import FrenchTips from "@/assets/images/booking/french-tips.png";
import GasTopup from "@/assets/images/booking/gas-topup.png";
import GelManiClasssicPedi from "@/assets/images/booking/gel-mani-classic-pedi.png";
import GelManicure from "@/assets/images/booking/gel-manicure.png";
import GelManipedi from "@/assets/images/booking/gel-manipedi.png";
import GelPedicure from "@/assets/images/booking/gel-pedicure.png";
import GelRemoval from "@/assets/images/booking/gel-removal.png";
import GeneralServicing from "@/assets/images/booking/general-servicing.png";
import KingBedMattress from "@/assets/images/booking/king-bed-mattress.png";
import LashLiftTint from "@/assets/images/booking/lash-lift-tint.png";
import LashLift from "@/assets/images/booking/lash-lift.png";
import LowerLash from "@/assets/images/booking/lower-lash.png";
import ManiPedi from "@/assets/images/booking/mani-pedi.png";
import Manicure from "@/assets/images/booking/manicure.png";
import MattressAddOn from "@/assets/images/booking/mattress-add-on.png";
import NailArt from "@/assets/images/booking/nail-art.png";
import NailExtension from "@/assets/images/booking/nail-extension.png";
import NightCurtain from "@/assets/images/booking/night-curtain.png";
import Pedicure from "@/assets/images/booking/pedicure.png";
import Portable from "@/assets/images/booking/portable.png";
import QueenBedMattress from "@/assets/images/booking/queen-bed-mattress.png";
import Removal from "@/assets/images/booking/removal.png";
import RepairDiagnostic from "@/assets/images/booking/repair-diagnostic.png";
import RugAddOn from "@/assets/images/booking/Rug-add-on.png";
import RugExtraLarge from "@/assets/images/booking/rug-extra-large.png";
import RugLarge from "@/assets/images/booking/rug-large.png";
import RugMedium from "@/assets/images/booking/rug-medium.png";
import RugSmall from "@/assets/images/booking/rug-small.png";
import Seater1 from "@/assets/images/booking/seater-1.png";
import Seater2 from "@/assets/images/booking/seater-2.png";
import Seater3 from "@/assets/images/booking/seater-3.png";
import Seater4 from "@/assets/images/booking/seater-4.png";
import Seater5 from "@/assets/images/booking/seater-5.png";
import SingleBedMattress from "@/assets/images/booking/single-bed-mattress.png";
import SofaAddOn from "@/assets/images/booking/sofa-add-on.png";
import SwedishMassage from "@/assets/images/booking/swedish-massage.png";
import ThaiMassage from "@/assets/images/booking/thai-massage.png";
import Wall from "@/assets/images/booking/wall.png";
import Window from "@/assets/images/booking/window.png";
import airconGeneralServicingCover from "@/assets/images/service-detail/aircon-general-servicing-cover.png";
import babysitterCover from "@/assets/images/service-detail/babysitter-cover.png";
import chemicalOverhaulCover from "@/assets/images/service-detail/chemical-overhaul-cover.png";
import chemicalWashCover from "@/assets/images/service-detail/chemical-wash-cover.png";
import compressorWashCover from "@/assets/images/service-detail/compressor-wash-cover.png";
import curtainCleaningCover from "@/assets/images/service-detail/curtain-cleaning-cover.png";
import deepCleaningCover from "@/assets/images/service-detail/deep-cleaning-cover.png";
import elderCareCover from "@/assets/images/service-detail/elder-care-cover.png";
import gasCover from "@/assets/images/service-detail/gas-cover.png";
import homeBeautyComboCover from "@/assets/images/service-detail/home-beauty-combo-cover.png";
import homeCleaningCover from "@/assets/images/service-detail/home-cleaning-cover.png";
import homeMassageCover from "@/assets/images/service-detail/home-massage-cover.png";
import lashesCover from "@/assets/images/service-detail/lashes-cover.png";
import mattressCover from "@/assets/images/service-detail/mattress-cover.png";
import petGroomingCover from "@/assets/images/service-detail/pet-grooming-cover.png";
import petSittingCover from "@/assets/images/service-detail/pet-sitting-cover.png";
import pramSeatCover from "@/assets/images/service-detail/pram-seat-cover.png";
import repairDiagnosticCover from "@/assets/images/service-detail/repair-diagnostic-cover.png";
import rugCleaningCover from "@/assets/images/service-detail/rug-cleaning-cover.png";
import sofaCover from "@/assets/images/service-detail/sofa-cover.png";
import type {
  AirconFrequencyOption,
  DurationOption,
  FrequencyOption,
} from "@/components/shared/service-radio-item/types";
import { PackageUnitTypeMapping } from "@/lib/line-items/helpers";
import { PackageFrequencyGroupEnum } from "@/types/booking";
import type { UpholsteryServiceName } from "@/types/service";

export const ServiceDetailMenuItems = [
  { label: "Service", key: "service" },
  { label: "Reviews", key: "reviews" },
  { label: "Details", key: "details" },
  { label: "FAQs", key: "faqs" },
];

export const HomeCleaningFrequencyOptions = [
  [
    {
      title: "Weekly",
      price: 18,
      description: "Scheduled weekly cleaning, minimum 4 sessions",
      shortDescription: "Every week · Min. 4 sessions",
      slogan: "Most Popular!",
      frequency: PackageFrequencyGroupEnum.WEEKLY,
      isRecurring: true,
      repeatEvery: PackageRecurrenceEnum.Week,
      repeatEveryTimes: 1,
    },
    {
      title: "Fortnightly",
      price: 18,
      description: "Scheduled cleaning every 2 weeks, minimum 4 sessions",
      shortDescription: "Every 2 weeks · Min. 4 sessions",
      frequency: PackageFrequencyGroupEnum.FORTNIGHT,
      isRecurring: true,
      repeatEvery: PackageRecurrenceEnum.Fortnight,
      repeatEveryTimes: 1,
    },
    {
      title: "> Once Per Week",
      price: 18,
      description:
        "For customized cleaning schedules and frequency, please contact us on WhatsApp",
      shortDescription: "Contact us on WhatsApp",
      frequency: PackageFrequencyGroupEnum.WEEKLY,
      isRecurring: true,
      unselectable: true,
      repeatEvery: PackageRecurrenceEnum.Week,
      repeatEveryTimes: 1,
      openModal: true,
    },
  ],
  [
    {
      title: "Anytime Cleaning",
      price: 23,
      description: "One time cleaning scheduled in advance at your convenience",
      frequency: PackageFrequencyGroupEnum.AD_HOC,
      repeatEvery: PackageRecurrenceEnum.AdHoc,
      repeatEveryTimes: 0,
      upsell: "Try our Recurring Services & Save More!",
    },
    {
      title: "Same/Next Day",
      price: 16,
      description:
        "Discounted cleaning for same or next day service that cannot be rescheduled or refunded once booked",

      frequency: PackageFrequencyGroupEnum.NEXT_DAY_AD_HOC,
      repeatEvery: PackageRecurrenceEnum.AdHoc,
      repeatEveryTimes: 0,
      upsell: "Try our Recurring Services & Save More!",
    },
  ],
];

export const AirconFrequencyOptions: AirconFrequencyOption[] = [
  {
    title: "Quarterly",
    slogan: "Most Popular",
    repeatEvery: PackageRecurrenceEnum.Year,
    repeatEveryTimes: 4,
    subTitle: "Save 10%",
  },
  {
    title: "Tri-yearly",
    repeatEvery: PackageRecurrenceEnum.Year,
    repeatEveryTimes: 3,
    subTitle: "Save 5%",
  },
  {
    title: "Just Once",
    repeatEvery: PackageRecurrenceEnum.AdHoc,
    repeatEveryTimes: 0,
    subTitle: "",
  },
];

export const ServiceDurationOptions: DurationOption[] = [
  {
    title: "4 Hours",
    slogan: "Value for money",
    value: "4",
    duration: 4,
  },
  {
    title: "3 Hours",
    value: "3",
    duration: 3,
  },
];

export const HomeCleaningFrequencyOptionItems = [
  {
    id: "Recurring",
    title: "Repeat Cleaning",
    options: HomeCleaningFrequencyOptions[0],
  },
  {
    id: "OneTime",
    title: "One Time Cleaning",
    options: HomeCleaningFrequencyOptions[1],
  },
];

export const HomeCleaningUpsellOptions: FrequencyOption[] =
  HomeCleaningFrequencyOptions[0];

export const airconServiceTypeOptions = [
  {
    value: ServiceTypeEnum.GeneralServicing,
    title: "General Servicing",
    subtitle: "As low as $16.00/unit",
    thirdTitle: "5 types of units available",
    description:
      "Aircon servicing involves cleaning the filters, fan, and drainage, disinfecting, and checking for electrical problems.",
    imgUrl: GeneralServicing,
    repeatEvery: PackageRecurrenceEnum.Year,
    duration: 4,
    name: "general-servicing",
  },
  {
    value: ServiceTypeEnum.ChemicalWash,
    title: "Chemical Wash",
    thirdTitle: "1 unit type available",
    subtitle: "As low as $68.00/unit",
    description:
      "Chemical wash removes dirt and mould by dismantling, cleaning, flushing, and checking gas pressure for poorly performing aircons.",
    imgUrl: ChemicalWash,
    repeatEvery: PackageRecurrenceEnum.AdHoc,
    duration: 0,
    name: "chemical-wash",
  },
  {
    value: ServiceTypeEnum.ChemicalOverhaul,
    title: "Chemical Overhaul",
    thirdTitle: "2 types of units available",
    subtitle: "As low as $110.00/unit",
    description:
      "Chemical overhaul is for aircons that aren't cold or have mould. It fully dismantles, cleans all parts, flushes drainage, checks gas pressure, and reassembles the unit for the most thorough cleaning.",
    imgUrl: ChemicalOverhaul,
    repeatEvery: PackageRecurrenceEnum.AdHoc,
    duration: 0,
    name: "chemical-overhaul",
  },
  {
    value: ServiceTypeEnum.CondenserWash,
    title: "Compressor Wash",
    thirdTitle: "1 unit type available",
    subtitle: "As low as $22.00/unit",
    description:
      "Compressor washing uses a jet wash to clean the coil and fan, removing dirt to improve airflow, cooling, and prevent damage.",
    imgUrl: CondenserWash,
    repeatEvery: PackageRecurrenceEnum.AdHoc,
    duration: 0,
    name: "compressor-wash",
  },
  {
    value: ServiceTypeEnum.GasTopUp,
    title: "Gas Top Up",
    thirdTitle: "All type available",
    subtitle: "As low as $80.00/unit",
    description:
      "Replenishes refrigerant levels to restore cooling efficiency, improve performance, and ensure optimal aircon function.",
    imgUrl: GasTopup,
    repeatEvery: PackageRecurrenceEnum.AdHoc,
    duration: 0,
    name: "gas-top-up",
  },
  {
    value: ServiceTypeEnum.RepairDiagnostic,
    title: "Repair & Diagnostic",
    subtitle: "As low as $60.00/unit",
    description:
      "Our service identifies and fixes AC issues, providing clear diagnosis, transparent pricing, and on-site repairs at no extra cost.",
    imgUrl: RepairDiagnostic,
    repeatEvery: PackageRecurrenceEnum.AdHoc,
    thirdTitle: "5 types of units available",
    duration: 0,
    isModal: true,
    name: "repaire",
  },
];

export const HomeMassageUnitTypeOptions = [
  {
    value: PackageUnitTypeEnum.BodyMassage,
    title: "Body Massage",
    imgUrl: SwedishMassage,
    price: 68,
  },
  {
    value: PackageUnitTypeEnum.FootMassage,
    title: "Foot Massage",
    imgUrl: FootMassage,
    price: 65,
  },
];

export type PetCareServiceType = "pet-sitting" | "pet-grooming";

type PetCareUnitTypeOption = {
  value: PackageUnitTypeEnum;
  title: string;
  imgUrl: string;
  price: number;
  caption?: string;
};

export const PetGroomingUnitTypeOptions: PetCareUnitTypeOption[] = [
  {
    value: PackageUnitTypeEnum.Cat,
    title: "Cat Grooming",
    imgUrl: CatGrooming,
    price: 55,
  },
  {
    value: PackageUnitTypeEnum.Dog,
    title: "Dog Grooming",
    imgUrl: DogGrooming,
    price: 50,
  },
];

export const PetSittingUnitTypeOptions = [
  {
    value: PackageUnitTypeEnum.Cat,
    title: "Cat Sitting",
    caption: "min 2 hours",
    imgUrl: CatSitting,
    price: 60,
  },
  {
    value: PackageUnitTypeEnum.Dog,
    title: "Dog Sitting",
    caption: "min 2 hours",
    imgUrl: DogSitting,
    price: 60,
  },
];

export const homeBeautyServiceTypeOptions = [
  {
    value: ServiceTypeEnum.Combo,
    serviceTitle: "Choose your ManiPedi Package",
    title: "ManiPedi",
    subtitle: "Starting at $84.00 +GST",
    description: "",
    imgUrl: ManiPedi,
    price: 84,
  },
  {
    value: ServiceTypeEnum.Manicure,
    serviceTitle: "Choose your Manicure Package",
    title: "Manicure",
    subtitle: "Starting at $37.00 +GST",
    description: "",
    imgUrl: Manicure,
    price: 37,
  },
  {
    value: ServiceTypeEnum.Pedicure,
    serviceTitle: "Choose your Pedicure Package",
    title: "Pedicure",
    subtitle: "Starting at $47.00 +GST",
    description: "",
    imgUrl: Pedicure,
    price: 47,
  },
];

export const lashesUnitTypeOptions = [
  {
    title: "Lash Lift",
    value: PackageUnitTypeEnum.LiftLashes,
    duration: "60 - 90",
    imgUrl: LashLiftTint,
    startPrice: 58,
  },
  {
    title: "Volume Lash Extensions (1D-6D)",
    value: PackageUnitTypeEnum.VolumeLashes,
    duration: "60 - 90",
    description: "90 - 120",
    imgUrl: D5Lash,
    startPrice: 68,
  },
  {
    title: "Hybrid Lash Extensions",
    value: PackageUnitTypeEnum.HybridLashes,
    duration: "120",
    imgUrl: FairyLash,
    startPrice: 95,
  },
];

export const getDeepCleaningAddOns = () => {
  return [
    {
      title: "Curtain",
      price: 54,
      imgUrl: CurtainAddOn,
    },
    {
      title: "Mattress",
      price: 108,
      imgUrl: MattressAddOn,
    },
    {
      title: "Sofa",
      price: 68,
      imgUrl: SofaAddOn,
    },
    {
      title: "Rug",
      price: 72,
      imgUrl: RugAddOn,
    },
  ];
};

export const getDeepCleaningPackageFromCode = (code: string) => {
  switch (code) {
    case "DC1BR42C":
      return {
        title: "501-750 SQFT",
        description: "Studio or 1 Bedroom, 2 Cleaners, 4 hours",
        numberOfCleaner: 2,
        order: 0,
      };
    case "DC2BR43C":
      return {
        title: "751-1000 SQFT",
        description: "Studio or 2 Bedroom, 3 Cleaners, 4 hours",
        numberOfCleaner: 3,
        order: 1,
      };
    case "DC3BR43C":
      return {
        title: "1001-1300 SQFT",
        description: "3 Bedroom, 3 Cleaners, 4 hours",
        numberOfCleaner: 3,
        order: 2,
      };
    case "DC4BR44C":
      return {
        title: "1301-1600 SQFT",
        description: "4 Bedroom, 4 Cleaners, 4 hours",
        numberOfCleaner: 4,
        order: 3,
      };
    case "DC5BR45C":
      return {
        title: "1601-2000 SQFT",
        description: "5 Bedroom, 5 Cleaners, 4 hours",
        numberOfCleaner: 5,
        order: 4,
      };
    case "DC5BR46C":
      return {
        title: "2001-2500 SQFT",
        description: "5 Bedroom, 6 Cleaners, 4 hours",
        numberOfCleaner: 6,
        order: 5,
      };
    case "DCSBR42C":
      return {
        title: "<500 SQFT",
        description: "Studio or 1 Bedroom, 2 Cleaners, 4 hours",
        numberOfCleaner: 2,
        order: 6,
      };
    default: {
      return {
        title: "",
        description: "",
        order: 0,
        numberOfCleaner: 1,
      };
    }
  }
};

export const LashesAddOns = ["HBLALL", "HBLARL"];

export const getLashesPackageFromCode = (code: string) => {
  switch (code) {
    case "HBLLL":
      return {
        title: "Lash Lift",
        imgUrl: LashLift,
        order: 0,
      };
    case "HBLLLT":
      return {
        title: "Lash Lift + Tint",
        imgUrl: LashLiftTint,
        order: 1,
      };
    case "HBLC1D":
      return {
        title: "Classic 1D",
        imgUrl: D1Lash,
        order: 1,
      };
    case "HBL2DL":
      return {
        title: "2D YY Lash",
        imgUrl: D2Lash,
        order: 2,
      };
    case "HBL3DL":
      return {
        title: "3-4D Lash",
        imgUrl: D3Lash,
        order: 3,
      };
    case "HBL5DL":
      return {
        title: "5-6D Lash",
        imgUrl: D5Lash,
        order: 4,
      };
    case "HBLFL":
      return {
        title: "Flower Lash",
        imgUrl: FlowerLash,
        order: 0,
      };
    case "HBLFAL":
      return {
        title: "Fairy Lash",
        imgUrl: FairyLash,
        order: 1,
      };
    case "HBLALL":
      return {
        title: "Lower Lash",
        imgUrl: LowerLash,
        order: 0,
      };
    case "HBLARL":
      return {
        title: "Removal",
        imgUrl: Removal,
        order: 1,
      };
    default: {
      return {
        title: "",
        imgUrl: "",
        order: 0,
      };
    }
  }
};

export const getHomeBeautyPackageFromCode = (code: string) => {
  switch (code) {
    case "HBNCCMP":
      return {
        imgUrl: ClassicManiPedi,
        title: "Classic ManiPedi",
        description:
          "Enjoy timeless elegance with our classic manicure and pedicure for the perfect polished look and well-groomed hands and feet. Regular polish included.",
      };
    case "HBNCGMP":
      return {
        imgUrl: GelManipedi,
        title: "Gel ManiPedi",
        description:
          "Indulge in enduring beauty with our gel polish service, cured flawlessly under LED light for up to 3 weeks of chip-free radiance. Basic cleaning included.",
      };
    case "HBNCGMCP":
      return {
        imgUrl: GelManiClasssicPedi,
        title: "Gel Mani + Classic Pedi",
        description:
          "Elevate your ManiPedi experience with a durable gel manicure and classic pedicure care.",
      };
    case "HBNCCMA":
      return {
        imgUrl: ClassicManicure,
        title: "Classic Manicure",
        description:
          "Elegant, clean nails, expertly shaped, polished and pampered for a classic and fresh look. Regular polish and short hand massage included.",
      };
    case "HBNCCPE":
      return {
        imgUrl: ClassicPedicure,
        title: "Classic Pedicure",
        description:
          "Step into relaxation with our classic pedicure. Enjoy expert nail care and polish finishing for soft and beautiful feet. Regular polish and short foot massage included.",
      };
    case "HBNCGMA":
      return {
        imgUrl: GelManicure,
        title: "Gel Manicure",
        description:
          "Elevate your nails with our gel manicure for a long-lasting, chip-resistant, and glossy finish for beautiful nails.",
      };
    case "HBNCGPE":
      return {
        imgUrl: GelPedicure,
        title: "Gel Pedicure",
        description:
          "Elevate your nails with our gel pedicure for a long-lasting, chip-resistant, and glossy finish for beautiful nails.",
        sortOrder: 1,
      };
    case "HBNANA":
      return {
        imgUrl: NailArt,
        title: "Nail Art (per nail)",
        description:
          "Express yourself in creative, personalized manicures and enjoy our nail art add on!",
        maxItem: 20,
        suffix: "/nail",
        mostPopular: true,
        minFreeGelAmount: 5,
      };
    case "HBNAFT":
      return {
        imgUrl: FrenchTips,
        title: "French Tips",
        description:
          "Perfect for anyone looking for a stylish and timeless design. It gives your manicure that extra touch of sophistication.",
        maxItem: 2,
        suffix: "/10 nails",
        minFreeGelAmount: 1,
      };
    case "HBNAEX":
      return {
        imgUrl: NailExtension,
        title: "Nail Extension",
        description:
          "Elevate your manicure with long-lasting nail extensions and get an even more glamorous manicure.",
        maxItem: 1,
        suffix: "/10 nails",
        minFreeGelAmount: 1,
      };
    case "HBNAGR":
      return {
        imgUrl: GelRemoval,
        title: "Gel Removal",
        description:
          "Seamless and precise gel removal for fresh, healthy nails.",
        maxItem: 2,
        sortOrder: 3,
        suffix: "/10 nails",
      };
    case "HBNAER":
      return {
        imgUrl: ExtensionRemoval,
        title: "Extension removal",
        description:
          "Gentle and precise nail extension removal, restoring your natural nails' beauty.",
        maxItem: 1,
        sortOrder: 4,
        suffix: "/10 nails",
      };
    case "HBNAEM":
      return {
        imgUrl: ExtendedMassage,
        title: "Extended Massage",
        description:
          "Rejuvenate and experience silky, smooth, callus-free hands or feet with this treatment.",
        maxItem: 1,
        sortOrder: 1,
        mostPopular: true,
      };
    case "HBNACT":
      return {
        imgUrl: CallusTreatment,
        title: "Callus Treatment",
        description:
          "Indulge in post-manicure bliss and extend your hand massage time.",
        maxItem: 1,
        sortOrder: 2,
        mostPopular: true,
      };
    case "HBNDFGR":
      return {
        imgUrl: GelRemoval,
        title: "Free Gel Removal",
        description:
          "Seamless and precise gel removal for fresh, healthy nails.",
        maxItem: 2,
      };
    default:
      return {
        imgUrl: "-",
        title: "-",
        description: "-",
        undefinedCode: true,
      };
  }
};

// ── HomeBeauty Add-On Configuration per Main Package ──

export type HomeBeautyAddOnOverride = {
  code: string;
  maxItem: number;
  maxItemLabel?: string; // e.g. "hand & foot", "foot", "hand", "20 nails"
  canIncludeFreeGel?: boolean;
};

export type HomeBeautyPackageAddOnConfig = {
  maxFreeGelUnits: number;
  allowedAddOns: HomeBeautyAddOnOverride[];
};

/**
 * Configuration map: main package code → allowed add-ons with overridden
 * maxItem and free gel eligibility. Controls which add-ons are shown and
 * their limits based on the selected main service.
 */
export const homeBeautyAddOnConfigByMainPackage: Record<
  string,
  HomeBeautyPackageAddOnConfig
> = {
  // ── ManiPedi (Combo) ──────────────────────────────────

  // Classic ManiPedi
  HBNCCMP: {
    maxFreeGelUnits: 0,
    allowedAddOns: [
      { code: "HBNAEM", maxItem: 2, maxItemLabel: "hand & foot" },
      { code: "HBNACT", maxItem: 1, maxItemLabel: "foot" },
    ],
  },
  // Gel ManiPedi
  HBNCGMP: {
    maxFreeGelUnits: 2,
    allowedAddOns: [
      {
        code: "HBNANA",
        maxItem: 20,
        maxItemLabel: "20 nails",
        canIncludeFreeGel: true,
      },
      {
        code: "HBNAFT",
        maxItem: 2,
        maxItemLabel: "hand & foot",
        canIncludeFreeGel: true,
      },
      {
        code: "HBNAEX",
        maxItem: 1,
        maxItemLabel: "hand",
        canIncludeFreeGel: true,
      },
      { code: "HBNAEM", maxItem: 2, maxItemLabel: "hand & foot" },
      { code: "HBNACT", maxItem: 1, maxItemLabel: "foot" },
      { code: "HBNAGR", maxItem: 2, maxItemLabel: "hand & foot" },
      { code: "HBNAER", maxItem: 2, maxItemLabel: "hand & foot" },
    ],
  },
  // Gel Mani + Classic Pedi
  HBNCGMCP: {
    maxFreeGelUnits: 1,
    allowedAddOns: [
      {
        code: "HBNANA",
        maxItem: 10,
        maxItemLabel: "10 nails",
        canIncludeFreeGel: true,
      },
      {
        code: "HBNAFT",
        maxItem: 1,
        maxItemLabel: "hand",
        canIncludeFreeGel: true,
      },
      {
        code: "HBNAEX",
        maxItem: 1,
        maxItemLabel: "hand",
        canIncludeFreeGel: true,
      },
      { code: "HBNAEM", maxItem: 2, maxItemLabel: "hand & foot" },
      { code: "HBNACT", maxItem: 1, maxItemLabel: "foot" },
      { code: "HBNAGR", maxItem: 1, maxItemLabel: "hand" },
      { code: "HBNAER", maxItem: 1, maxItemLabel: "hand" },
    ],
  },

  // ── Manicure Only ─────────────────────────────────────

  // Classic Manicure
  HBNCCMA: {
    maxFreeGelUnits: 0,
    allowedAddOns: [{ code: "HBNAEM", maxItem: 1, maxItemLabel: "hand" }],
  },
  // Gel Manicure
  HBNCGMA: {
    maxFreeGelUnits: 1,
    allowedAddOns: [
      {
        code: "HBNANA",
        maxItem: 10,
        maxItemLabel: "10 nails",
        canIncludeFreeGel: true,
      },
      {
        code: "HBNAFT",
        maxItem: 1,
        maxItemLabel: "hand",
        canIncludeFreeGel: true,
      },
      {
        code: "HBNAEX",
        maxItem: 1,
        maxItemLabel: "hand",
        canIncludeFreeGel: true,
      },
      { code: "HBNAEM", maxItem: 1, maxItemLabel: "hand" },
      { code: "HBNAGR", maxItem: 1, maxItemLabel: "hand" },
      { code: "HBNAER", maxItem: 1, maxItemLabel: "hand" },
    ],
  },

  // ── Pedicure Only ─────────────────────────────────────

  // Classic Pedicure
  HBNCCPE: {
    maxFreeGelUnits: 0,
    allowedAddOns: [
      { code: "HBNAEM", maxItem: 1, maxItemLabel: "foot" },
      { code: "HBNACT", maxItem: 1, maxItemLabel: "foot" },
    ],
  },
  // Gel Pedicure
  HBNCGPE: {
    maxFreeGelUnits: 1,
    allowedAddOns: [
      {
        code: "HBNANA",
        maxItem: 10,
        maxItemLabel: "10 nails",
        canIncludeFreeGel: true,
      },
      {
        code: "HBNAFT",
        maxItem: 1,
        maxItemLabel: "foot",
        canIncludeFreeGel: true,
      },
      {
        code: "HBNAEX",
        maxItem: 1,
        maxItemLabel: "foot",
        canIncludeFreeGel: true,
      },
      { code: "HBNAEM", maxItem: 1, maxItemLabel: "foot" },
      { code: "HBNACT", maxItem: 1, maxItemLabel: "foot" },
      { code: "HBNAGR", maxItem: 1, maxItemLabel: "foot" },
      { code: "HBNAER", maxItem: 1, maxItemLabel: "foot" },
    ],
  },
};

export const getHomeBeautyAddOnConfig = (
  mainPackageCode: string,
): HomeBeautyPackageAddOnConfig | null => {
  return homeBeautyAddOnConfigByMainPackage[mainPackageCode] ?? null;
};

export const BodyMassageCode = {
  Swedish: ["MASBM60", "MASBM90", "MASBM120"],
  DeepTissue: ["MADTBM60", "MADTBM90", "MADTBM120"],
  Aroma: ["MAATBM60", "MAATBM90", "MAATBM120"],
  Thai: ["MATLBM60", "MATLBM90", "MATLBM120"],
};

export const MessageAddOnCode = "MAAOFM30";
export const PetAddOnCodes = ["RPCAOBT", "RPCAOS"];
export const PetShowerAddOnCode = "RPCAOS";
export const PetSittingCode = "RPSAD02";

export const BodyMassageTypes = [
  {
    imgUrl: SwedishMassage,
    title: "Swedish Massage",
    description: "Gentle strokes, pure relaxation.",
    codes: BodyMassageCode.Swedish,
  },
  {
    imgUrl: DeepTissueMassage,
    title: "Deep Tissue Massage",
    description: "Target tension, restore strength.",
    codes: BodyMassageCode.DeepTissue,
  },
  {
    imgUrl: AromaticMassage,
    title: "Aromatic Oil Massage",
    description: "Rejuvenate with fragrant bliss.",
    codes: BodyMassageCode.Aroma,
  },
  {
    imgUrl: ThaiMassage,
    title: "Thai Massage",
    description: "Stretch, balance, and relax.",
    codes: BodyMassageCode.Thai,
  },
];

export const PetGroomingTypes = [
  {
    title: "Full Grooming",
    description: "Basic grooming plus haircut and styling.",
    recommended: true,
    keyword: "Full",
  },
  {
    title: "Basic Grooming",
    description: "For a quick refresh and routine care.",
    recommended: false,
    keyword: "Basic",
  },
  {
    title: "Express Grooming",
    description: "Essential care for basic pet hygiene",
    recommended: false,
    keyword: "Express",
  },
];

export const firstDogPkgCode = "PSFDGL10";
export const firstCatPkgCode = "PSFCGS";

export const getPetGroomingAddOnPackageTitle = (code: string) => {
  switch (code) {
    case "RPCAOBT":
      return "Teeth Cleaning";
    case "RPCAOS":
      return "Shower";
  }
  return "-";
};

export const getPetPackages = (code: string) => {
  switch (code) {
    // dog
    case "RPCDBG5":
    case "RPCDEG5":
    case "RPCDFG5":
      return {
        title: "Small",
        description: "<5kg",
      };

    case "RPCDBG10":
    case "RPCDEG10":
    case "RPCDFG10":
      return {
        title: "Medium",
        description: "5-10kg",
      };

    case "RPCDBG29":
    case "RPCDEG29":
    case "RPCDFG29":
      return {
        title: "Large",
        description: "11-29kg",
      };

    case "RPCDBG30":
    case "RPCDEG30":
    case "RPCDFG30":
      return {
        title: "Extra Large",
        description: ">30kg",
      };
    // cat
    case "RPCCFGS":
    case "RPCCBGS":
    case "RPCCEGS":
      return {
        title: "Short Coated",
        description: "",
      };
    case "RPCCFGL":
    case "RPCCBGL":
    case "RPCCEGL":
      return {
        title: "Long Coated",
        description: "",
      };

    default:
      return null;
  }
};

export const massageDuration = [1, 1.5, 2];

export const getHomeMassageAddOns = () => {
  return [
    {
      imgUrl: FootMassage,
      title: "Foot Massage",
      price: "35",
      duration: 35,
    },
  ];
};

export const getCarpetUpholsteryFromUnit = (
  unitType: PackageUnitTypeEnum,
  unitSize: UnitSizeEnum,
) => {
  switch (unitType) {
    case PackageUnitTypeEnum.Mattress:
      if (unitSize === UnitSizeEnum.Single) {
        return {
          title: "Single Bed Mattress",
          description: "91x190cm",
          img: SingleBedMattress,
          recommended: false,
          sortOrder: 0,
          maxItem: 6,
        };
      }
      if (unitSize === UnitSizeEnum.Queen) {
        return {
          title: "Queen Bed Mattress",
          description: "152x190cm",
          img: QueenBedMattress,
          recommended: false,
          sortOrder: 1,
          maxItem: 6,
        };
      }
      if (unitSize === UnitSizeEnum.King) {
        return {
          title: "King Bed Mattress",
          description: "182x190cm",
          img: KingBedMattress,
          recommended: false,
          sortOrder: 2,
          maxItem: 6,
        };
      }
      if (unitSize === UnitSizeEnum.BabyCot) {
        return {
          title: "Baby Cot",
          img: BabyCot,
          recommended: false,
          sortOrder: 3,
          maxItem: 6,
        };
      }
      break;
    case PackageUnitTypeEnum.Sofa:
      if (unitSize === UnitSizeEnum.Seater_1) {
        return {
          title: "1 Seater",
          img: Seater1,
          sortOrder: 0,
          maxItem: 6,
        };
      }
      if (unitSize === UnitSizeEnum.Seater_2) {
        return {
          title: "2 Seater",
          img: Seater2,
          sortOrder: 1,
          maxItem: 6,
        };
      }
      if (unitSize === UnitSizeEnum.Seater_3) {
        return {
          title: "3 Seater",
          img: Seater3,
          sortOrder: 2,
          maxItem: 6,
        };
      }
      if (unitSize === UnitSizeEnum.Seater_4) {
        return {
          title: "4 Seater",
          img: Seater4,
          sortOrder: 3,
          maxItem: 6,
        };
      }
      if (unitSize === UnitSizeEnum.Seater_5) {
        return {
          title: "5 Seater",
          img: Seater5,
          sortOrder: 4,
          maxItem: 6,
        };
      }
      if (unitSize === UnitSizeEnum.Chair) {
        return {
          title: "Chair",
          img: Chair,
          sortOrder: 5,
          maxItem: 6,
        };
      }
      if (unitSize === UnitSizeEnum.ArmChair) {
        return {
          title: "Arm Chair",
          img: ArmChair,
          sortOrder: 6,
          maxItem: 6,
        };
      }
      break;
    case PackageUnitTypeEnum.Rug:
      if (unitSize === UnitSizeEnum.Small) {
        return {
          sortOrder: 0,
          title: "Small",
          img: RugSmall,
          description: "up to 100x100cm",
          maxItem: 6,
        };
      }
      if (unitSize === UnitSizeEnum.Medium) {
        return {
          sortOrder: 1,
          title: "Medium",
          img: RugMedium,
          description: "up to 100x200cm",
          maxItem: 6,
        };
      }
      if (unitSize === UnitSizeEnum.Large) {
        return {
          sortOrder: 2,
          title: "Large",
          description: "up to 200x200cm",
          img: RugLarge,
          maxItem: 6,
        };
      }
      if (unitSize === UnitSizeEnum.ExtraLarge) {
        return {
          sortOrder: 3,
          title: "ExtraLarge",
          description: "300x300cm",
          img: RugExtraLarge,
          maxItem: 6,
        };
      }
      break;
    case PackageUnitTypeEnum.Carpet:
      if (unitSize === UnitSizeEnum.C_600SqftBelow) {
        return {
          title: "Small",
          sortOrder: 0,
          maxItem: 6,
        };
      }
      if (unitSize === UnitSizeEnum.C_601SqftTo_900Sqft) {
        return {
          title: "Medium",
          sortOrder: 1,
          maxItem: 6,
        };
      }
      if (unitSize === UnitSizeEnum.C_901SqftTo_1500Sqft) {
        return {
          title: "Large",
          sortOrder: 2,
          maxItem: 6,
        };
      }
      if (unitSize === UnitSizeEnum.C_4000SqftAbove) {
        return {
          title: "Extra Large",
          sortOrder: 3,
          maxItem: 6,
        };
      }
      break;
    case PackageUnitTypeEnum.ChildSeat:
      if (unitSize === UnitSizeEnum.All)
        return {
          title: "Car Seat",
          sortOrder: 1,
          img: CarSeat,
          maxItem: 6,
        };
      break;
    case PackageUnitTypeEnum.BabyPram:
      if (unitSize === UnitSizeEnum.All)
        return {
          title: "Baby Pram",
          img: BabyPram,
          sortOrder: 0,
          maxItem: 6,
        };
      break;
    default:
      return {
        title: "",
        img: "",
      };
  }
};

export const getCurtainCleaningFromCode = (code: string) => {
  switch (code) {
    case "SCDC":
      return {
        sortOrder: 0,
        title: "Day Curtain",
        description: "",
        img: DayCurtain,
        maxItem: 6,
      };
    case "SCNC":
      return {
        sortOrder: 1,
        title: "Night Curtain",
        description: "",
        img: NightCurtain,
        maxItem: 6,
      };
    case "SCBC":
      return {
        sortOrder: 2,
        title: "Blinds Curtain",
        description: "",
        img: BlindsCurtain,
        maxItem: 6,
      };
    default:
      return {
        sortOrder: 0,
        title: "-",
        description: "",
        img: DayCurtain,
        maxItem: 0,
      };
  }
};

export const getUpholsteryServicesType = (
  name: UpholsteryServiceName,
): ServiceTypeEnum => {
  switch (name) {
    case "curtain-cleaning":
      return ServiceTypeEnum.SteamCleaning;
    default:
      return ServiceTypeEnum.DeepExtraction;
  }
};

export const getAirconUnitsFromUnit = (
  serviceType: ServiceTypeEnum | undefined,
  unitType: PackageUnitTypeEnum,
): { title: string; sortOrder: number; img: string; maxItem: number } => {
  switch (serviceType) {
    case ServiceTypeEnum.GeneralServicing:
      if (unitType === PackageUnitTypeEnum.Wall) {
        return {
          title: PackageUnitTypeMapping[unitType],
          img: Wall,
          sortOrder: 0,
          maxItem: 8,
        };
      }
      if (unitType === PackageUnitTypeEnum.Ceiling) {
        return {
          title: PackageUnitTypeMapping[unitType],
          img: Ceiling,
          sortOrder: 1,
          maxItem: 8,
        };
      }
      if (unitType === PackageUnitTypeEnum.Ducted) {
        return {
          title: PackageUnitTypeMapping[unitType],
          img: Ducted,
          sortOrder: 2,
          maxItem: 8,
        };
      }
      if (unitType === PackageUnitTypeEnum.Portable) {
        return {
          title: PackageUnitTypeMapping[unitType],
          img: Portable,
          sortOrder: 3,
          maxItem: 8,
        };
      }
      if (unitType === PackageUnitTypeEnum.Window) {
        return {
          title: PackageUnitTypeMapping[unitType],
          img: Window,
          sortOrder: 4,
          maxItem: 8,
        };
      }
      break;
    case ServiceTypeEnum.ChemicalWash:
      if (unitType === PackageUnitTypeEnum.Wall) {
        return {
          title: PackageUnitTypeMapping[unitType],
          img: Wall,
          sortOrder: 0,
          maxItem: 6,
        };
      }
      if (unitType === PackageUnitTypeEnum.Ceiling) {
        return {
          title: PackageUnitTypeMapping[unitType],
          img: Ceiling,
          sortOrder: 1,
          maxItem: 6,
        };
      }
      break;
    case ServiceTypeEnum.ChemicalOverhaul:
      if (unitType === PackageUnitTypeEnum.Wall) {
        return {
          title: PackageUnitTypeMapping[unitType],
          img: Wall,
          sortOrder: 0,
          maxItem: 6,
        };
      }
      break;
    case ServiceTypeEnum.CondenserWash:
      if (unitType === PackageUnitTypeEnum.All) {
        return {
          title: PackageUnitTypeMapping[unitType],
          img: AllUnits,
          sortOrder: 0,
          maxItem: 8,
        };
      }
      break;
    case ServiceTypeEnum.GasTopUp:
      if (unitType === PackageUnitTypeEnum.All) {
        return {
          title: "All Units (Compressor)",
          img: AllUnits,
          sortOrder: 0,
          maxItem: 6,
        };
      }
      break;
    default:
      return {
        title: "",
        img: "",
        sortOrder: 0,
        maxItem: 0,
      };
  }
  return {
    title: "",
    img: "",
    sortOrder: 0,
    maxItem: 0,
  };
};

export type ServiceDetailKey =
  | "home-cleaning"
  | "mattress-cleaning"
  | "rug-cleaning"
  | "curtain-cleaning"
  | "pram-seat"
  | "sofa-cleaning"
  | "home-massage"
  | "aircon-service-GENERAL_SERVICING"
  | "aircon-service-CHEMICAL_WASH"
  | "aircon-service-CHEMICAL_OVERHAUL"
  | "aircon-service-CONDENSER_WASH"
  | "aircon-service-GAS_TOP_UP"
  | "aircon-service-REPAIR_DIAGNOSTIC"
  | "pet-grooming"
  | "pet-sitting"
  | "home-beauty"
  | "lashes"
  | "deep-cleaning"
  | "elder-care"
  | "babysitter";

export const serviceDetailCover: Record<ServiceDetailKey, string> = {
  "home-cleaning": homeCleaningCover,
  "mattress-cleaning": mattressCover,
  "rug-cleaning": rugCleaningCover,
  "curtain-cleaning": curtainCleaningCover,
  "pram-seat": pramSeatCover,
  "sofa-cleaning": sofaCover,
  "aircon-service-GENERAL_SERVICING": airconGeneralServicingCover,
  "aircon-service-CHEMICAL_WASH": chemicalWashCover,
  "aircon-service-CHEMICAL_OVERHAUL": chemicalOverhaulCover,
  "aircon-service-CONDENSER_WASH": compressorWashCover,
  "aircon-service-GAS_TOP_UP": gasCover,
  "aircon-service-REPAIR_DIAGNOSTIC": repairDiagnosticCover,
  "home-beauty": homeBeautyComboCover,
  "home-massage": homeMassageCover,
  "pet-grooming": petGroomingCover,
  "pet-sitting": petSittingCover,
  lashes: lashesCover,
  "deep-cleaning": deepCleaningCover,
  "elder-care": elderCareCover,
  babysitter: babysitterCover,
};

export const AirconServiceNames = [
  "general-servicing",
  "chemical-overhaul",
  "compressor-wash",
  "gas-top-up",
  "chemical-wash",
];

export const ElderCareFrequencyOptions = [
  [
    {
      title: "Weekly",
      price: 20,
      slogan: "Most Popular!",
      frequency: PackageFrequencyGroupEnum.WEEKLY,
      isRecurring: true,
      repeatEvery: PackageRecurrenceEnum.Week,
      repeatEveryTimes: 1,
      code: "ECHCWE14",
      description: "-",
    },
    {
      title: "Fortnightly",
      price: 20,
      frequency: PackageFrequencyGroupEnum.FORTNIGHT,
      isRecurring: true,
      repeatEvery: PackageRecurrenceEnum.Fortnight,
      repeatEveryTimes: 1,
      code: "ECHCFE14",
      description: "-",
    },
  ],
  [
    {
      title: "One Time Care",
      price: 25,
      frequency: PackageFrequencyGroupEnum.AD_HOC,
      repeatEvery: PackageRecurrenceEnum.AdHoc,
      repeatEveryTimes: 0,
      code: "ECHCAE14",
      description: "-",
    },
  ],
];

export const ElderCareFrequencyOptionItems = [
  {
    title: "Repeat Care",
    options: ElderCareFrequencyOptions[0],
  },
  {
    title: "One Time Care",
    options: ElderCareFrequencyOptions[1],
  },
];

export const BabysitterFrequencyOptions = [
  {
    label: "Recurring Babysitter",
    title: "Weekly",
    price: 20,
    frequency: PackageRecurrenceEnum.Week,
    repeatEveryTimes: 1,
  },
  {
    label: "One time Babysitter",
    title: "One time Session",
    price: 25,
    frequency: PackageRecurrenceEnum.AdHoc,
    repeatEveryTimes: 1,
  },
];

export type BabyDurationOptionType = {
  title: string;
  duration: number;
  price: number;
};

export const BabysitterRecurringOptions: BabyDurationOptionType[] = [
  {
    title: "Weekly - 4 Hours per session",
    duration: 4,
    price: 20,
  },
  {
    title: "Weekly - 3 Hours per sessions",
    duration: 3,
    price: 22,
  },
];

export const BabysitterAdhocOptions: BabyDurationOptionType[] = [
  {
    title: "One-time 4 Hours per sessions",
    duration: 4,
    price: 25,
  },
  {
    title: "One-time 3 Hours per sessions",
    duration: 3,
    price: 25,
  },
];
